import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'graphql_get_discoveryFeedsByListingId';

const query = `
    query discoveryFeedsByListingId($listingIds: [String!]!, $types: [DiscoveryXploreFeedType!]) {
        discoveryFeedsByListingId(listingIds: $listingIds, types: $types) {
            results {
                id
                title
                items {
                    ... on SearchDiscoveryFeedItem {
                        place {
                            name {
                                full
                            }
                            imageHref
                            uuid
                        }
                    }
                }
            }
        }
    }
`;

async function discoveryFeedsByListingIdGraphQl({listingId}) {
    const params = {
        listingIds: [listingId],
        types: ['DESTINATION']
    };
    return graphqlQuery(OPERATION_NAME, query, params);
}

export default discoveryFeedsByListingIdGraphQl;
export {discoveryFeedsByListingIdGraphQl, OPERATION_NAME, query};
